import React from "react";
import { Button, MenuItem, Select } from "@mui/material";
import { MessageDialog } from "../../../components/message-dialog";
import { AdmLayout } from "../../../layouts/base/adm.layout";
import { TutorialModel } from "../../../models/TutorialModel";
import { AdminFilterBar, AdminPageHeader, countLabel, DataTable, EmptyState } from "../../../components/ui";
import { CLIENT_PAGE_SIZE, useTutorialAdmin } from "./use-tutorial-admin";
import { buildTutorialColumns } from "./tutorial-columns";
import TutorialFormModal from "./components/TutorialFormModal";

export const Tutorial = () => {
    const {
        formik,
        openBackdrop,
        openModal,
        tutorialViewModel,
        setTutorialViewModel,
        durationText,
        setDurationText,
        btnSaveDisabled,
        allTutorial,
        searchTerm,
        setSearchTerm,
        statusFilter,
        setStatusFilter,
        clientPage,
        setClientPage,
        dialogModel,
        filteredTutorials,
        totalFiltered,
        pagedTutorials,
        isEditing,
        editTutorial,
        handleClickEnable,
        handleOpenCreate,
        handleCloseModal,
        productViewInitial,
        productSchema,
    } = useTutorialAdmin();

    const columns = buildTutorialColumns({ onToggle: handleClickEnable, onEdit: editTutorial });

    return (
        <AdmLayout hasLogo={true} loading={openBackdrop}>
            <MessageDialog
                emoji={dialogModel.emoji}
                open={dialogModel.open}
                title={dialogModel.title}
                message={dialogModel.message}
                onConfirm={dialogModel.onConfirm}
                confirmButtonText={dialogModel.confirmButtonText}
            />

            <TutorialFormModal
                open={openModal}
                onClose={handleCloseModal}
                isEditing={isEditing}
                btnSaveDisabled={btnSaveDisabled}
                formik={formik}
                tutorialViewModel={tutorialViewModel}
                setTutorialViewModel={setTutorialViewModel}
                durationText={durationText}
                setDurationText={setDurationText}
                productViewInitial={productViewInitial}
                productSchema={productSchema}
            />

            <AdminPageHeader
                title="Mídia"
                subtitle="Gestão de vídeos e tutoriais"
                action={
                    <Button variant="contained" color="primary" onClick={handleOpenCreate}>
                        Novo tutorial
                    </Button>
                }
            />

            <AdminFilterBar
                search={searchTerm}
                onSearch={(value) => {
                    setSearchTerm(value);
                    setClientPage(1);
                }}
                placeholder="Buscar por título..."
                filters={
                    <Select
                        size="small"
                        value={statusFilter}
                        onChange={(e) => {
                            setStatusFilter(e.target.value as "all" | "active" | "inactive");
                            setClientPage(1);
                        }}
                        sx={{ height: 40, minWidth: 160, borderRadius: "10px" }}
                    >
                        <MenuItem value="all">Todos</MenuItem>
                        <MenuItem value="active">Ativo</MenuItem>
                        <MenuItem value="inactive">Inativo</MenuItem>
                    </Select>
                }
                count={countLabel(filteredTutorials.length, allTutorial.length)}
            />

            <DataTable<TutorialModel>
                columns={columns}
                rows={pagedTutorials}
                rowKey={(row) => String(row.id ?? row.title)}
                loading={openBackdrop}
                page={clientPage}
                pageSize={CLIENT_PAGE_SIZE}
                totalRows={totalFiltered}
                onPageChange={setClientPage}
                countLabel={countLabel(filteredTutorials.length, allTutorial.length)}
                minWidth={700}
                emptyState={
                    <EmptyState
                        title="Nenhum tutorial encontrado"
                        description="Tente ajustar o termo de busca ou cadastre um novo tutorial."
                        actionLabel="Novo tutorial"
                        onAction={handleOpenCreate}
                    />
                }
            />
        </AdmLayout>
    );
};
